import * as channelsRoutines from '../Containers/Channels/channelRoutines';

const initialState = {
    groups: [],
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case channelsRoutines.fetchGroups.SUCCESS:
            return {
                ...state,
                groups: action.payload,
            };
        default:
            return state;
    }
}
